{
  "clear": "清除",
  "invalid": "（无效）",
  "loading": "正在加载...",
  "noResults": "无结果"
}
